// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_FRP_Async from "../Specular.FRP.Async/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
var withPrevious = function (dictMonadFRP) {
    return function (source) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.readDynamic(dictMonadFRP.MonadEffect0())(source))(function (initial) {
            return Specular_FRP_Base.foldDyn(dictMonadFRP)(function ($$new) {
                return function (old) {
                    return {
                        previous: new Data_Maybe.Just(old.current),
                        current: $$new
                    };
                };
            })({
                previous: Data_Maybe.Nothing.value,
                current: initial
            })(Specular_FRP_Base.changed(source));
        });
    };
};
var withLoadedSuccess$prime = function (loader) {
    return function (request) {
        return function (handler) {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Async.asyncRequest(Specular_Dom_Builder.monadEffectBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(request)))(function (result) {
                return Specular_FRP_Replaceable.dynamic_(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(result)(function (v) {
                    if (v instanceof Specular_FRP_Async.NotRequested) {
                        return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit);
                    };
                    if (v instanceof Specular_FRP_Async.Loading) {
                        return loader;
                    };
                    if (v instanceof Specular_FRP_Async.Loaded && v.value0 instanceof Data_Either.Left) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Builder_Class.text(Specular_Dom_Builder.monadDomBuilderBuilder)("Error loading data"))(function () {
                            return Specular_Dom_Builder_Class.el(Specular_Dom_Builder.monadDomBuilderBuilder)("pre")(Specular_Dom_Builder_Class.text(Specular_Dom_Builder.monadDomBuilderBuilder)(v.value0.value0));
                        });
                    };
                    if (v instanceof Specular_FRP_Async.Loaded && v.value0 instanceof Data_Either.Right) {
                        return handler(v.value0.value0);
                    };
                    throw new Error("Failed pattern match at Specular.Extra (line 26, column 5 - line 32, column 36): " + [ v.constructor.name ]);
                }));
            });
        };
    };
};
var withLoadedSuccess = function (request) {
    return function (handler) {
        return withLoadedSuccess$prime(Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit))(request)(handler);
    };
};
var waitUntil = function (dictMonadFRP) {
    return function (canRun) {
        return function (e) {
            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Callback.newCallback(Specular_Dom_Builder.monadEffectBuilder))(function (pushToQueue) {
                return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Base.holdDyn(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Maybe.Nothing.value)(pushToQueue.event))(function (isWaiting) {
                    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Base.newEvent(Specular_Dom_Builder.monadEffectBuilder))(function (result) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Callback.attachEvent(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Functor.map(Specular_FRP_Base.functorEvent)(Data_Maybe.Just.create)(e))(pushToQueue.callback))(function () {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_FRP_Base.subscribeDyn_(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(function (v) {
                                return Control_Applicative.when(Effect.applicativeEffect)(v.value0)((function () {
                                    if (v.value1 instanceof Data_Maybe.Just) {
                                        return function __do() {
                                            result.fire(v.value1.value0)();
                                            return Specular_Callback.triggerCallback(pushToQueue.callback)(Data_Maybe.Nothing.value)();
                                        };
                                    };
                                    if (v.value1 instanceof Data_Maybe.Nothing) {
                                        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                                    };
                                    throw new Error("Failed pattern match at Specular.Extra (line 47, column 11 - line 51, column 33): " + [ v.value1.constructor.name ]);
                                })());
                            })(Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Tuple.Tuple.create)(canRun))(isWaiting)))(function () {
                                return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(result.event);
                            });
                        });
                    });
                });
            });
        };
    };
};
var unlinesWidget = /* #__PURE__ */ (function () {
    var $14 = Data_Foldable.sequence_(Specular_Dom_Builder.applicativeBuilder)(Data_Foldable.foldableArray);
    var $15 = Data_Foldable.intercalate(Data_Foldable.foldableArray)(Data_Monoid.monoidArray)([ Specular_Dom_Builder_Class.el_(Specular_Dom_Builder.monadDomBuilderBuilder)("br") ]);
    var $16 = Data_Functor.map(Data_Functor.functorArray)(Control_Applicative.pure(Control_Applicative.applicativeArray));
    return function ($17) {
        return $14($15($16($17)));
    };
})();
var times = "\xd7";
var timesIcon = /* #__PURE__ */ Specular_Dom_Builder_Class.text(Specular_Dom_Builder.monadDomBuilderBuilder)(times);
var nbsp = /* #__PURE__ */ Specular_Dom_Builder_Class.text(Specular_Dom_Builder.monadDomBuilderBuilder)("\xa0");
var classesFromString = /* #__PURE__ */ (function () {
    var $18 = Data_Array.filter((function () {
        var $22 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
        return function ($23) {
            return $22(Data_String_Common["null"]($23));
        };
    })());
    var $19 = Data_Functor.map(Data_Functor.functorArray)(Data_String_Common.trim);
    var $20 = Data_String_Common.split(" ");
    return function ($21) {
        return Specular_Dom_Element.classes($18($19($20($21))));
    };
})();
export {
    focusElement,
    focusNode
} from "./foreign.js";
export {
    withLoadedSuccess,
    withLoadedSuccess$prime,
    waitUntil,
    withPrevious,
    nbsp,
    times,
    timesIcon,
    unlinesWidget,
    classesFromString
};
//# sourceMappingURL=index.js.map
